import { BIGQUERY_GROUP } from '../../constants';

export type DisplayFromValue = 'sm' | 'md' | 'lg' | 'xl';

export const MIXPANEL_EVENT_NAME = 'Clicked sign in';

export const BIGQUERY_TYPE = 'clicked_header.sign_in.button_click_header';

export const BIGQUERY_EVENT = {
    type: BIGQUERY_TYPE,
    group: BIGQUERY_GROUP,
};

export const MIXPANEL_EVENT = {
    eventName: MIXPANEL_EVENT_NAME,
    eventData: { 'Source Component': 'Header' },
};

export const LO_HEADER_NAV_SOURCE_CLIENTS = 'lo_header_clients';
export const LO_HEADER_NAV_SOURCE_FREELANCERS = 'lo_header_freelancers';
